import React from 'react';
import { Box } from '@mui/material';

import FacebookButton from '../../Authentication/FacebookButton';
import GoogleButton from '../../Authentication/GoogleButton';
import CsamButton from '../../Authentication/CsamButton';

function OAuthButtons({ onAuth, space }: any) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mb: 4,
        gap: 2,
        flexWrap: 'wrap',
      }}
    >
      <Box>
        <FacebookButton onClick={onAuth} />
      </Box>
      <Box>
        <GoogleButton onClick={onAuth} />
      </Box>
      {!!space.csam_client_id && (
        <Box>
          <CsamButton fullText space={space} />
        </Box>
      )}
    </Box>
  );
}

export default OAuthButtons;
